/**=========================================================
 * Module: app-page-title.js
 * Handles page title
 =========================================================*/

App.directive('appPageTitle', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/title.html',
      controller: 'TitleController',
      restrict: 'E',
      replace: true
  };

});